<template>
	<div class="row mx-0" style="padding-left: 1.5rem; position: relative;">

		<!-- object field name entry (object only) -->
		<div class="col-4 p-0 text-nowrap pr-2" style="min-width: 200px; margin-left: -1.5rem !important;">
			<input type="text" class="form-control mt-1" value="$id" style="display: inline !important;" disabled>
			<label class="col-form-label font-weight-bold mt-1" style="display: inline !important;">:</label>
		</div>

		<!-- value type selector -->
		<div class="col-2 pl-1 pr-0" style="min-width: 140px; width: 100%;">
			<select class="form-control mt-1" v-model="item.type" :disabled="disabled">
				<option value="auto">Auto</option>
				<option value="string.short">Text String</option>
				<option value="number">Number</option>
			</select>
		</div>

		<!-- value entry controls -->
		<div class="pl-1 pr-0" :class="getValueTypeClass(item.type)" style="min-width: 200px;">
			<!-- compact types -->
			<input v-if="item.type === 'string.short'" :disabled="disabled" v-model="item.value" type="text" class="form-control mt-1" placeholder="[Text ID Value]">
			<input v-if="item.type === 'number'" :disabled="disabled" v-model="item.value" type="number" class="form-control mt-1" placeholder="[Numeric ID Value]">
			<input v-if="item.type === 'auto'" placeholder="(Will be auto-generated)" type="text" class="form-control mt-1" disabled>
		</div>
	</div>
</template>

<script>
import ObjectEditorItem from "@/components/utilities/ObjectEditorItem";

export default {
	name: "object-editor-id",
	extends: ObjectEditorItem,
	props: {
		source: { type: null, required : false },
		disabled : { type: Boolean },
	},
	// created( )
	// {
	// 	console.log( `ID: ${this.item.value}` );
	// }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/utilities/ObjectEditorId.vue